/**
 * Callback for Array.sort() to sort an object array
 * alphabetically by the value of a given key
 */
export const sortByStringInKey =
  <T extends Record<string, any>>(key = 'id') =>
  (a: T, b: T) =>
    a[key].localeCompare(b[key]);
